import { __extends } from "tslib";
import { GetCampaignRequest, GetCampaignResponse } from "../models/index";
import { deserializeAws_restJson1GetCampaignCommand, serializeAws_restJson1GetCampaignCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetCampaignCommand = /** @class */ (function (_super) {
    __extends(GetCampaignCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetCampaignCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetCampaignCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: GetCampaignRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetCampaignResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCampaignCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetCampaignCommand(input, context);
    };
    GetCampaignCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetCampaignCommand(output, context);
    };
    return GetCampaignCommand;
}($Command));
export { GetCampaignCommand };
//# sourceMappingURL=GetCampaignCommand.js.map